import React from "react";
import { AdSlot } from "../components/ads/AdSlot";
import { wrapIrSlots } from "../components/ads/irSlots";
import SmiWidget from "../components/smiWidgets/SmiWidget";
import { SourceInfo } from "../components/SourceInfo/SourceInfo";
import { splitNewsContent } from "../utils/adChunks";

function getAdfoxComponents(isDesktop, isFull, widgetBlocks) {
    const adfoxComponents = {
        1: <SmiWidget isDesktop={isDesktop} isFull={isFull} blockIds={widgetBlocks.ir1} />,
        2: <SmiWidget isDesktop={isDesktop} isFull={isFull} blockIds={widgetBlocks.ir2} />,
        3: <SmiWidget isDesktop={isDesktop} isFull={isFull} blockIds={widgetBlocks.ir3} />,
        4: <SmiWidget isDesktop={isDesktop} isFull={isFull} blockIds={widgetBlocks.ir4} />,
    };
    return adfoxComponents;
}

function NewsText({ news, isDesktop, isFull, widgetBlocks }) {
    const contentRef = React.useRef(null);
    const chunks = splitNewsContent(news);
    const adfoxNum = chunks.filter((c) => c === "ADFOX").length;
    const selectedComponentsMap = wrapIrSlots(getAdfoxComponents(isDesktop, isFull, widgetBlocks), {
        isFull,
        isDesktop,
    });
    let cnt = 1;
    const publishDate = news.publish_date.toString().split(" ")[0] + " " + news.publish_date.toString().split(" ")[1];

    return (
        <div className="newsDetail">
            <div className="main-news-wrap">
                <div className="content">
                    <div className="publish-date">{publishDate}</div>
                    <div className="news-title-200">{news.title}</div>
                </div>
                <div className="image">
                    <img src={news.image} alt={news.title} />
                </div>
            </div>
            <SourceInfo url={news.source_url} title={news.source_title} />
            <div className="text-news" ref={contentRef}>
                {chunks.map((chunk, i) => {
                    if (chunk === "ADFOX" && cnt <= adfoxNum && isFull) {
                        cnt += 1;
                        return <React.Fragment key={`ad-${cnt - 1}`}>{selectedComponentsMap[cnt - 1]}</React.Fragment>;
                    }
                    if (i === chunks.length - 1) {
                        cnt = 1;
                    }
                    return (
                        <React.Fragment key={i}>
                            <p hidden={!isFull && chunk === "ADFOX"} dangerouslySetInnerHTML={{ __html: chunk }} />
                        </React.Fragment>
                    );
                })}
            </div>
            <AdSlot
                slot="aa1"
                isFull={isFull}
                isDesktop={isDesktop}
                fallback={<SmiWidget isDesktop={isDesktop} isFull={isFull} blockIds={widgetBlocks.aa} />}
            />
        </div>
    );
}

NewsText.defaultProps = {
    teasers: [],
};

export default NewsText;
